import React from "react";
import "./LoadingFallback.css";

const LoadingFallback = ({ compact = false, message = "Loading content" }) => {
  return (
    <div
      className={`loading-fallback${compact ? " loading-fallback--compact" : ""}`}
      role="status"
      aria-live="polite"
    >
      <div className="loading-spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      <p className="loading-fallback__message">{message}</p>
    </div>
  );
};

export default LoadingFallback;
